import { render, staticRenderFns } from "./CaseHeader.vue?vue&type=template&id=01003b28&scoped=true&"
import script from "./CaseHeader.vue?vue&type=script&lang=js&"
export * from "./CaseHeader.vue?vue&type=script&lang=js&"
import style0 from "./CaseHeader.vue?vue&type=style&index=0&id=01003b28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01003b28",
  null
  
)

export default component.exports